export default __webpack_public_path__ + "static/media/banner_1.7c079290.jpg";